import { mutatorAction } from 'satcheljs';
import type SearchScenarioId from '../store/schema/SearchScenarioId';
import getScenarioStore from '../selectors/getScenarioStore';

/**
 * Records (or clears) the action source that initiated a search exit.
 *
 * Some exit paths do not end the session directly. In Mail, exiting search restores the
 * previously selected folder, and it is that node selection which ends the session using its
 * own replacement source ('SelectFolderNode'), discarding the trigger the user actually used.
 * Capturing the source here lets `endSearchSessionOrchestrator` report the original trigger.
 *
 * Pass `undefined` to clear a pending source when an exit is intercepted and the session stays
 * active.
 */
const setSearchPendingExitSourceMutator: (
    scenarioId: SearchScenarioId,
    actionSource: string | undefined,
    forceExit?: boolean
) => void = mutatorAction(
    'setSearchPendingExitSource',
    (scenarioId: SearchScenarioId, actionSource: string | undefined, forceExit = false): void => {
        const store = getScenarioStore(scenarioId);
        store.pendingExitActionSource = actionSource;
        store.pendingExitForceExit = actionSource ? forceExit : undefined;
    }
);

export default setSearchPendingExitSourceMutator;
